import React, { useState } from "react";
import { Link } from "react-router-dom";

const FaqSection = () => {
  const [activeFaq, setActiveFaq] = useState(0);

  const toggleFaq = (index) => {
    setActiveFaq((prev) => (prev === index ? null : index));
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const faqsLeft = [
    {
      number: "1",
      question: "What is ServiceNow, and how can it benefit my business?",
      answer:
        " ServiceNow is a cloud-based workflow automation platform that improves IT operations, customer service, HR, and business process management, helping businesses become more efficient and scalable.",
    },
    {
      number: "2",
      question: "Why should I choose TechStr for ServiceNow implementation?",
      answer: "TechStr has a team of certified experts with years of experience in ServiceNow development, customization, and support, delivering tailored solutions for various industries.",
    },
    {
      number: "3",
      question: "Can TechStr help integrate ServiceNow with my existing systems?",
      answer: "We offer roles in ServiceNow consulting, development, project management, and administration. Check our [Careers Page] for current openings.",
    },
  
  ];

  const faqsRight = [
      {
      number: "4",
      question: "What career opportunities are available at TechStr?",
      answer: "We offer roles in ServiceNow consulting, development, project management, and administration. Check our [Careers Page] for current openings.",
    },{
      number: "5",
      question: "Do I need ServiceNow certification to apply?",
      answer: "While certifications are preferred, we also provide training and mentorship programs to help professionals upskill.",
    },
    {
      number: "6",
      question: "How can I apply for an internship at TechStr?",
      answer: " Our internship programs provide hands-on experience in ServiceNow. Visit our [Internship Page] to learn more and apply.",
    },
   
  ];

  const renderFaqs = (faqs, offset) =>
    faqs.map((faq, index) => {
      const currentIndex = index + offset;
      const isActive = activeFaq === currentIndex;

      return (
        <li key={faq.number} className={`accordion block ${isActive ? "active-block" : ""}`}>
          <div
            className={`acc-btn ${isActive ? "active" : ""}`}
            onClick={() => toggleFaq(currentIndex)}
          >
            <span className="number">{faq.number}</span>
            {faq.question}
            <span className="arrow"></span>
          </div>
          <div
            className="acc_body"
            style={{
              maxHeight: isActive ? "1000px" : "0", // Adjust the height as needed
              overflow: "hidden",
              transition: "max-height 0.3s ease",
            }}
          >
            <div className="content">
              <p>{faq.answer}</p>
            </div>
          </div>
        </li>
      );
    });

  return (
    <section className="faq pt-150 pb-115" style={{ backgroundColor: '#f4f5fc' }}>
      <div className="container">
        <div className="da-sec-titlte text-center mb-30">
          <h2 className="title">Frequently Asked Questions (FAQs)</h2>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="da-left-faq">
              <div className="xb-faq xb-faq-two da-faq">
                <ul className="accordion_box clearfix list-unstyled">
                  {renderFaqs(faqsLeft, 0)}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="da-right-faq">
              <div className="xb-faq xb-faq-two da-faq">
                <ul className="accordion_box clearfix list-unstyled">
                  {renderFaqs(faqsRight, faqsLeft.length)}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="xb-btn text-center mt-70">
          <Link onClick={ClickHandler} to="/contact" className="thm-btn thm-btn--fill_icon thm-btn--data thm-btn--data_blue">
            <div className="xb-item--hidden">
              <span className="xb-item--hidden-text">Book a Discover Call</span>
            </div>
            <div className="xb-item--holder">
              <span className="xb-item--text xb-item--text1">Book a Discover Call</span>
              <div className="xb-item--icon">
                <i className="fal fa-plus"></i>
              </div>
              <span className="xb-item--text xb-item--text2">Book a Discover Call</span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
